import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HistoriskFilterProvider } from './contexts/HistoriskFilterContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <HistoriskFilterProvider>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/org/:orgKey" element={<App />} />
        <Route path="/org/:orgKey/folder/:id" element={<App />} />
        <Route path="/org/:orgKey/file/:id" element={<App />} />
        <Route path="/folder/:id" element={<App />} />
        <Route path="/file/:id" element={<App />} />
      </Routes>
    </HistoriskFilterProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
